export default function GetFormattedDate(dateTime: string | number | Date){
    let inputDate = new Date(dateTime);

    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    // let day = inputDate.getDate();
    // var month = months[inputDate.getMonth()];
    // let year = inputDate.getFullYear().toString();

    const day = inputDate.getUTCDate();  // Use getUTCDate() to get the day in UTC
    const month = months[inputDate.getUTCMonth()];  // Use getUTCMonth() to get the month in UTC
    const year = inputDate.getUTCFullYear().toString();  // Use getUTCFullYear() to get the year in UTC
    
    let dateFormatted = `${month} ${day}, ${year}`; 

    return dateFormatted;
}
export function GetRoundUpValue(event:any)
{
    event.preventDefault();
    const iClaimCMEHours = event.target.value;
    let roundUpValue: string ;
    var step = 0.25;
    var inv = 1.0 / step;
    roundUpValue = (Math.round(Number(iClaimCMEHours) * inv) / inv).toString();
          
    return roundUpValue;
}

//function to set the cursor to top of the page
export function SetCursorToTop(className?: string, currentElement?: Element): void {

  // Check if className is provided
  if (className) {
    if (currentElement) {
      //this will scroll to the first element with the provided class name inside the currentElement
      currentElement.getElementsByClassName(className)[0]?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    }
    else {
      // Find the element with the provided class name
      const element = document.querySelector('.' + className);
      if (element instanceof Element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // If element is not found, scroll to the top of the page
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

  } else {
    // If no className provided, scroll to the top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}